<template>
<div>
  <form method="POST" v-on:submit.prevent="addProspecto">
    <div class="modal fade" id="modalCliente" role="dialog" aria-labelledby="modalClienteLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalClienteLabel">
              Agregar prospecto
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12 mb-3" v-if="perfil == 'U' || perfil == 'A' || perfil == 'S'">
                <div class="form-group">
                  <label for="modal-cliente-vendedor">Vendedor:</label>
                  <catalogo-vendedores v-model="formClient.vendedor" name="vendedor" id="modal-cliente-vendedor"></catalogo-vendedores>
                  <div v-if="errors && errors.vendedor" class="text-danger">
                      {{ errors.vendedor[0] }}
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-3" v-if="is_prestamos">
                <label for="modal-cliente-primer-nombre">Primer nombre:</label>
                <input id="modal-cliente-primer-nombre" type="text" class="form-control" placeholder="Ingrese primer nombre" v-model="formClient.first_name" maxlength="25" required>
                <div v-if="errors && errors.first_name" class="text-danger">
                  {{ errors.first_name[0] }}
                </div>
              </div>

              <div class="col-lg-6 mb-3" v-if="is_prestamos">
                <label for="modal-cliente-segundo-nombre">Segundo nombre:</label>
                <input id="modal-cliente-segundo-nombre" type="text" class="form-control" placeholder="Ingrese segundo nombre" v-model="formClient.second_name" maxlength="25">
                <div v-if="errors && errors.second_name" class="text-danger">
                  {{ errors.second_name[0] }}
                </div>
              </div>

              <div class="col-lg-6 mb-3" v-if="is_prestamos">
                <label for="modal-cliente-first-surname">Primer apellido:</label>
                <input id="modal-cliente-first-surname" type="text" class="form-control" placeholder="Ingrese primer apellido" v-model="formClient.first_surname" maxlength="25">
                <div v-if="errors && errors.first_surname" class="text-danger">
                  {{ errors.first_surname[0] }}
                </div>
              </div>

              <div class="col-lg-6 mb-3" v-if="is_prestamos">
                <label for="modal-cliente-second-surname">Segundo apellido:</label>
                <input id="modal-cliente-second-surname" type="text" class="form-control" placeholder="Ingrese segundo apellido" v-model="formClient.second_surname" maxlength="25">
                <div v-if="errors && errors.second_surname" class="text-danger">
                  {{ errors.second_surname[0] }}
                </div>
              </div>

              <div class="col-lg-12 mb-3" v-if="!is_prestamos">
                <label for="modal-cliente-nombre">Nombre:</label>
                <input id="modal-cliente-nombre" type="text" class="form-control" placeholder="Ingrese nombre" v-model="formClient.name" maxlength="100" required>
                <div v-if="errors && errors.name" class="text-danger">
                  {{ errors.name[0] }}
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <label for="modal-cliente-telefono">Teléfono</label>
                <phone id="modal-cliente-telefono" maxlength="25" v-model="formClient.telefono"></phone>
                <div v-if="errors && errors.telefono" class="text-danger">
                  {{ errors.telefono[0] }}
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <label for="modal-cliente-email">Correo</label>
                <input id="modal-cliente-email" type="email" class="form-control" placeholder="Correo electrónico" maxlength="125" v-model="formClient.email">
                <div v-if="errors && errors.email" class="text-danger">
                  {{ errors.email[0] }}
                </div>
              </div>
            </div>
            <div class="form-group" v-if="false">
              <label>
                Segmento:
                <a href="#" v-on:click.prevent="getSegmentos" class="font-weight-bold" v-if="!loadingSegmentos">
                  <small>(actualizar)</small>
                </a>
                <span v-else>
                    <i class="fas fa-spinner fa-pulse"></i>
                </span>
              </label>
              <select2 
                v-model="formClient.segmento" 
                name="segmento" 
                id="segmento"
                :disabled="loadingSegmentos">
                <option v-for="segmento in segmentos" v-bind:value="segmento.CODIGO_SEGMENTO"> {{ segmento.DESCRIPCION_SEGMENTO }}
                </option>
              </select2>
              <div v-if="errors && errors.segmento" class="text-danger">
                  {{ errors.segmento[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" v-on:click="closeModal">Cancelar</button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Cargando...
              </span>
              <span v-else>Crear</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
</template>
<script>
	export default {
		props: ['perfil'],

    data(){
      return {
        formClient: {
          vendedor: '',
          name: '',
          documento: '',
          direccion: '',
          fecha_nacimiento: '',
          nit: '',
          notas: '',
          corporacion: '',
          puesto: '',
          segmento: '',
          telefono: '',
          celular: '',
          email: '',
          usuario_facebook: '',
          tipoPersona: '',

          first_name: '',
          second_name: '',
          first_surname: '',
          second_surname: ''
        },
        errors: {},
        loading: false
      }
    },

    methods: {
      closeModal: function(){
        this.formClient.vendedor = '';
        this.formClient.name = '';
        this.formClient.documento = '';
        this.formClient.direccion = '';
        this.formClient.fecha_nacimiento = '';
        this.formClient.nit = '';
        this.formClient.notas = '';
        this.formClient.corporacion = '';
        this.formClient.puesto = '';
        this.formClient.segmento = '';
        this.formClient.telefono = '';
        this.formClient.celular = '';
        this.formClient.email = '';
        this.formClient.usuario_facebook = '';
        this.formClient.tipoPersona = '';
        this.formClient.first_name = ''
        this.formClient.second_name = ''
        this.formClient.first_surname = ''
        this.formClient.second_surname = ''
        $('#modalCliente').modal('hide');
      },

      addProspecto: function(){
        var url = '/clientes';
        this.loading = true;

        axios.post(url, this.formClient).then(response => {
          $('#codigo_cliente').append($('<option>', {
            value: response.data.CODIGO_CLIENTE,
            text: response.data.NOMBRE_CLIENTE
          })).val(response.data.CODIGO_CLIENTE).trigger('change');
          this.closeModal();
        }).catch(error=>{
          this.$toasted.show('Error al agregar Cliente.');
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        }).then(()=>{
          this.loading = false;
        });
      },
    },

    computed: {
      is_prestamos(){
        return crm.tipoCrm.is_prestamos
      }
    }
  }
</script>